import { z } from "zod";

/** One AI-scored company category as the score endpoints return it. */
export const ScoreCompanyCategoryInfoSchema = z.object({
	id: z.number(),
	category: z.string(),
	description: z.string(),
	type: z.string(),
});

export const ScoreCompanyCategoryInfoResponseSchema = z.array(ScoreCompanyCategoryInfoSchema);

export type ScoreCompanyCategoryInfo = z.infer<typeof ScoreCompanyCategoryInfoSchema>;
